module.exports = __webpack_public_path__ + "media/images/icon/icons8-Details Popup-eac5bb9f8eb824cd6eac9f825783b964.png";